import { createClient } from "@supabase/supabase-js";

const url  = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.error("Supabase env vars missing — check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env");
}

export const supabase = createClient(url, anonKey);
